import { AdidasLogo } from '@/components/PricingPage/BrandLogos/AdidasLogo';
import { AmazonLogo } from '@/components/PricingPage/BrandLogos/AmazonLogo';
import { AudibleLogo } from '@/components/PricingPage/BrandLogos/AudibleLogo';
import { DJILogo } from '@/components/PricingPage/BrandLogos/DJILogo';
import { EcosiaLogo } from '@/components/PricingPage/BrandLogos/EcosiaLogo';
import { GoogleLogo } from '@/components/PricingPage/BrandLogos/GoogleLogo';
import { HMLogo } from '@/components/PricingPage/BrandLogos/HMLogo';
import { TheNorthFaceLogo } from '@/components/PricingPage/BrandLogos/TheNorthFaceLogo';
import { ReviewGrid } from '@/components/Reviews/ReviewGrid';
import UBTrustBoxContainer from '@/components/UBTrustPilot';
const BRAND_LOGOS = [{
  id: 'google',
  Logo: GoogleLogo
}, {
  id: 'amazon',
  Logo: AmazonLogo
}, {
  id: 'adidas',
  Logo: AdidasLogo
}, {
  id: 'dji',
  Logo: DJILogo
}, {
  id: 'audible',
  Logo: AudibleLogo
}, {
  id: 'the-north-face',
  Logo: TheNorthFaceLogo
}, {
  id: 'hm',
  Logo: HMLogo
}, {
  id: 'ecosia',
  Logo: EcosiaLogo
}];
export const ReviewsSection = () => <div className="overflow-hidden bg-gray-50 pt-16 dark:bg-gray-900" data-sentry-component="ReviewsSection" data-sentry-source-file="ReviewsSection.tsx">
    <div className="flex w-full flex-col items-center">
      <div className="flex flex-col items-center px-4">
        <h2 className="mb-8 text-center font-semibold text-3xl">
          Trusted by <span className="text-pink-600">leading brands</span> and{' '}
          <span className="text-pink-600">5M+ creators</span>
        </h2>
        <UBTrustBoxContainer data-sentry-element="UBTrustBoxContainer" data-sentry-source-file="ReviewsSection.tsx" />
      </div>
      <div className="mx-auto mt-8 hidden w-full max-w-6xl items-center justify-between gap-8 px-6 text-gray-700 md:flex dark:text-gray-400">
        {BRAND_LOGOS.map(({
        id,
        Logo
      }) => <Logo className="h-auto min-w-0 shrink" key={id} />)}
      </div>
      <div className="mt-16">
        <ReviewGrid data-sentry-element="ReviewGrid" data-sentry-source-file="ReviewsSection.tsx" />
      </div>
    </div>
  </div>;
export default ReviewsSection;